  <template>
  <div class="col-md-12">
    <div class="form-group">
      <input type="text" class="form-control" v-model="search" placeholder="Search">
    </div>
    <div class="table-responsive">
      <!--<table class="table table-striped table-bordered table-hover" style="width:100%">-->
      <table class="table table-hover" style="width:100%">
          <thead width="400px">
              <tr style="color:white"> <!--class="thead-light" -->
                  <th scope="col" class="col-xs-2 col-md-2" style="color:black">問題</th>
                  <th scope="col" class="col-xs-10 col-md-10" style="color:black" align="left">解釋與答案</th>
                  
              </tr>
          </thead>
          <tbody>
              <tr>
                <td><font color="#000000">代購流程</font></td>
                <td><font color="#000000">1. 你可以在網上購物，填寫我們公司地址(點擊 <button class="btn btn-warning" @click="orderrequest">填寫信息</button> 獲得我們公司地址）</br>
                                             &nbsp&nbsp&nbsp 如果您還不是會員，請點擊 <button class="btn btn-warning" @click="tobemember">成為會員</button></br>
                                             &nbsp&nbsp&nbsp 或您需要我們為您在當地購買貨品,請與我們聯繫</br>
                                          2. 當我們收到您的訂購後會為你計算運費和收款</br>
                                          3. 然後寄到你的地址</font></td>
              </tr>
              <tr>
                <td><font color="#000000">可寄的物品</font></td>
                <td><font color="#000000">1. 大多數網上商店購物的商品,包括 ebay and amazon <b>(香水，易燃易爆除外)</b> </br>
                                          2. 歡迎合併你訂購的商品, 透過一次過的投遞, 從而節省您的郵費</br></font></td>
              </tr>
              <tr>
                <td><font color="#000000">付款方式</font></td>
                <td><font color="#000000">1. 香港客戶: 可以匯款或轉賬港幣到中銀香港</br>
                                          2. 其他地區客戶: 可以匯款到 Paypal</br></font></td>
              </tr>
              <tr>
                <td><font color="#000000">運費</font></td>
                <td><font color="#000000">1. 香港客戶：首1kg為<b>230港幣</b>，之後每kg<b>100港幣</b></br>
                                          2. 其他地區客戶: 在落訂之前, 你可以與我們核實運費</br></font></td>
              </tr>
              <tr>
                <td><font color="#000000">如何成為會員</font></td>
                <td><font color="#000000">1. 請點擊 <button class="btn btn-warning" @click="tobemember">成為會員</button></b></br>
                                          2. 輸入您的電郵地址,我們會向您發送一個連結,您便可以直接登錄</br>
                                          &nbsp&nbsp&nbsp 同時我們將向您發送另一個連結來方便您更新帳戶密碼</br>
                                          3. 您可以使用您的電子郵件地址添加代購訂單</font></td>
              </tr>
          </tbody>
      </table>
    </div>
 <button @click="prevPage" class="float-left btn btn-outline-info btn-sm"><i class="fas fa-arrow-left"></i> Previous</button> 
 <button @click="nextPage" class="float-right btn btn-outline-info btn-sm">Next <i class="fas fa-arrow-right"></i></button>
  </div>
</template>

<script>
/*eslint-disable*/
import firebase from 'firebase'
import {db} from '../main'
import { mapGetters, mapActions } from 'vuex' //1-Jan-19

export default {
  name: 'product',
  data: () => ({
    users: [],
    currentSort:'name',
    currentSortDir:'asc',
    search: '',
    searchSelection: '',
    pageSize: 5,
    currentPage: 1,
    lists: [],
    cartlabel: 'Add to cart'
  }),
  firestore () {
    return {lists: db.collection('products')
    }

  },
  methods:{
    tobemember: function(){
          this.$router.push('/signup') 
    },
    orderrequest: function(){
          this.$router.push('/contact') 
    },
    sort:function(s) {
      if(s === this.currentSort) {
        this.currentSortDir = this.currentSortDir==='asc'?'desc':'asc';
      }
      this.currentSort = s;
    },
    nextPage:function() {
      if((this.currentPage*this.pageSize) < this.lists.length) this.currentPage++;
    },
    prevPage:function() {
      if(this.currentPage > 1) this.currentPage--;
    }
  },

  computed: {
    sortedActivity:function() {
      return this.lists.sort((a,b) => {
        let modifier = 1;
        if(this.currentSortDir === 'desc') modifier = -1;
        if(a[this.currentSort] < b[this.currentSort]) return -1 * modifier;
        if(a[this.currentSort] > b[this.currentSort]) return 1 * modifier;
        return 0;
      }).filter((row, index) => {
        let start = (this.currentPage-1)*this.pageSize;
        let end = this.currentPage*this.pageSize;
        if(index >= start && index < end) return true;
      });
    },

    filteredList () {
      return this.lists.filter((data) => {
        //alert('Search: ' + this.search.toLowerCase() + ' data: ' + data.category.toLowerCase());
        let name = data.name.toLowerCase().match(this.search.toLowerCase());
        let category = data.category.toLowerCase().match(this.search.toLowerCase());
        let descr = data.descr.toLowerCase().match(this.search.toLowerCase());
        let currency = data.currency.toLowerCase().match(this.search.toLowerCase());
        //alert('Search: ' + this.search.toLowerCase() + ' result: ' + channel);
        return name || category || descr || currency;
      }).filter((row, index) => {
        let start = (this.currentPage-1)*this.pageSize;
        let end = this.currentPage*this.pageSize;
        if(index >= start && index < end) return true;
      });
    }
  },

  created () {
  },

}
</script>

<style>
th {
  cursor:pointer;
  /* width: 500px !important; */
  white-space: nowrap;
}

tr {
  white-space: nowrap;
}

.wrapup {
    white-space: pre-wrap; /* css-3 */    
    white-space: -moz-pre-wrap; /* Mozilla, since 1999 */
    white-space: -pre-wrap; /* Opera 4-6 */    
    white-space: -o-pre-wrap; /* Opera 7 */    
    word-wrap: break-word; width: 500px/* Internet Explorer 5.5+ */
   
}

</style>



// WEBPACK FOOTER //
// src/components/flow.vue